(() => {
  if (window.ryppleCartProtectionBound) return;
  window.ryppleCartProtectionBound = true;
  const reopenKey = 'rypple-reopen-cart-after-protection';

  const restoreDrawer = () => {
    try {
      if (sessionStorage.getItem(reopenKey) !== '1') return;
      sessionStorage.removeItem(reopenKey);
      customElements.whenDefined('cart-drawer').then(() => {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      });
    } catch (_) {
      // A blocked session store should not affect cart changes.
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreDrawer, { once: true });
  } else {
    restoreDrawer();
  }

  document.addEventListener('change', async (event) => {
    const toggle = event.target.closest('[data-rp-protection-toggle]');
    if (!toggle) return;

    const card = toggle.closest('[data-rp-protection-card]');
    const error = card?.querySelector('[data-rp-protection-error]');
    const allToggles = document.querySelectorAll('[data-rp-protection-toggle]');
    const isAdding = toggle.checked;
    const id = isAdding ? Number(toggle.dataset.variantId) : toggle.dataset.lineKey;

    if (!id) {
      toggle.checked = !isAdding;
      if (error) {
        error.textContent = 'Unable to update the cart. Please refresh and try again.';
        error.hidden = false;
      }
      return;
    }

    allToggles.forEach((input) => { input.disabled = true; });
    if (card) card.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;

    try {
      const response = await fetch(isAdding ? '/cart/add.js' : '/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(isAdding ? { items: [{ id, quantity: 1 }] } : { id, quantity: 0 })
      });
      if (!response.ok) throw new Error('Cart update failed');
      if (toggle.closest('cart-drawer')) {
        try { sessionStorage.setItem(reopenKey, '1'); } catch (_) { /* optional */ }
      }
      window.location.reload();
    } catch (_) {
      toggle.checked = !isAdding;
      allToggles.forEach((input) => { input.disabled = false; });
      if (card) card.removeAttribute('aria-busy');
      if (error) {
        error.textContent = 'Unable to update the cart. Please try again.';
        error.hidden = false;
      }
    }
  });
})();
